<template>
  <div class="share-mask-component">
    <ym-popup class="popup"
              v-model="showMask"
              get-container="body"
              position="top"
    >
      <div v-if="showMask">
        <slot>
          <div class="img-block">
            <ym-img class="share-img"
                    :src="require('@/assets/img/default/share_bg.png')"
                    alt="分享背景"
            />
          </div>
        </slot>
      </div>
    </ym-popup>
  </div>
</template>

<script>
  import { Popup } from '@ymba/ym-ui';
  import ClipboardJS from 'clipboard';
  import {
    isAppWebView,
    isWeiXinBrowser,
    handleRunAppFn,
  } from '@/utils';

  export default {
    name: 'ShareMask',
    components: {
      'ym-popup': Popup,
    },
    data() {
      return {
        showMask: false,
      };
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      message: {
        type: String,
        default: '',
        required: true,
      },
      sharePath: {
        type: String,
      },
    },
    watch: {
      show(val) {
        if (val) {
          this.handleShowMask();
        }
      },
      showMask(val) {
        this.$emit('update:show', val);
      },
    },
    methods: {
      handleShowMask() {
        if (isWeiXinBrowser()) {
          this.showMask = true;
          return;
        }
        if (isAppWebView()) {
          this.$emit('share');
          const wechatShare = this.$wechat.getWechatMenuShareAppParams();
          handleRunAppFn('shareLink', wechatShare);
          return;
        }
        const message = `<span style="color: #222;font-size: 16px">${this.message}</span>
          <div class="share-mask-path-block"
          id="copy-btn"
          data-clipboard-action="copy"
          data-clipboard-target="#sharepath"
          @click.native="handleCopy">
          <div class="share-mask-path"
          id="sharepath"
          style="word-break: break-all;">${this.sharePath}</div>
          <span class="share-mask-copy-btn">点此复制</span></div>
        `;
        this.$dialog.alert({
          message,
          confirmButtonText: '好的',
          closeOnClickOverlay: false,
        }).then(() => {
          this.$emit('share');
          this.$emit('update:show', false);
        });
        this.$nextTick(() => {
          const $copyBtn = document.getElementById('copy-btn');
          $copyBtn.addEventListener('click', () => {
            this.handleCopy();
          });
        });
      },
      handleHiddenMask() {
        this.showMask = false;
      },
      handleCopy() {
        const clipboard = new ClipboardJS('#copy-btn');
        clipboard.on('success', (e) => {
          this.$toast('内容已复制到剪切板');
          e.clearSelection();
        });
        clipboard.on('error', () => {
          this.$toast('复制失败，请手动复制');
        });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .popup {
    background: none;
  }

  .share-mask-path-block {
    font-weight: 700;
    white-space: normal;
    display: inline-block;
  }

  .share-mask-path {
    font-size: @font-size-base;
    color: @color-text-lighter;
  }

  .share-mask-copy-btn {
    word-break: keep-all;
    font-size: @font-size-small;
    color: @color-link;
  }

  .img-block {
    display: flex;
    justify-content: flex-end;
    padding: @size-base 46px 0 0;
  }

  .share-img {
    width: 455px;
    height: 603px;
  }
</style>
